import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInfoFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInfoFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c16de5e529918f4dbfb9940dd00580cfc56b52df', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '98f8ef32ec4702fe6f4b2dd4b42538469a341728', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b7a74e0f33cd056ce4f2a4b5069335252e26c842', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m1.25 5.56a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-4 3.44v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4h-2a.5.5 0 0 1-.5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-info-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-info-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-info-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInfoFilled$1);
            }
            break;
    } });
}

const CosmosIconInfoFilled = CosmosIconInfoFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInfoFilled, defineCustomElement };
